/**
 * Simulation Hub Page — merged Simulation Dashboard, Scenarios, and Analytics.
 */
import React, { Suspense, useState } from 'react'
import { observer } from 'mobx-react-lite'

const SimulationDashboardPage = React.lazy(() => import('./SimulationDashboardPage'))
const SimulationScenariosPage = React.lazy(() => import('./SimulationScenariosPage'))
const SimulationAnalyticsPage = React.lazy(() => import('./SimulationAnalyticsPage'))

type Tab = 'dashboard' | 'scenarios' | 'analytics'

const SimulationHubPage = observer(() => {
  const [activeTab, setActiveTab] = useState<Tab>('dashboard')

  const tabs: { key: Tab; label: string }[] = [
    { key: 'dashboard', label: 'Dashboard' },
    { key: 'scenarios', label: 'Scenarios' },
    { key: 'analytics', label: 'Analytics' },
  ]

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-xl sm:text-2xl font-bold text-foreground">Simulation</h1>
        <p className="text-sm text-muted-foreground mt-1">
          Run simulations, manage scenarios, and analyze results
        </p>
      </div>

      <div className="flex gap-1 border-b border-border">
        {tabs.map((tab) => (
          <button
            key={tab.key}
            onClick={() => setActiveTab(tab.key)}
            className={`px-4 py-2 text-sm font-medium border-b-2 transition-colors ${
              activeTab === tab.key
                ? 'border-violet-600 text-violet-600'
                : 'border-transparent text-muted-foreground hover:text-foreground'
            }`}
          >
            {tab.label}
          </button>
        ))}
      </div>

      <Suspense fallback={<div className="text-center py-8 text-muted-foreground">Loading...</div>}>
        {activeTab === 'dashboard' && <SimulationDashboardPage />}
        {activeTab === 'scenarios' && <SimulationScenariosPage />}
        {activeTab === 'analytics' && <SimulationAnalyticsPage />}
      </Suspense>
    </div>
  )
})

export default SimulationHubPage
